import { render, staticRenderFns } from "./OccupationListComponent.vue?vue&type=template&id=0e20af8c"
import script from "./OccupationListComponent.vue?vue&type=script&lang=js"
export * from "./OccupationListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports